import styles from './_UserProfile.module.scss';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectLoggedInUser,
    selectShowUserProfileOverlay,
    selectZoneDropdownValues,
    selectZoneLabel,
    selectZoneValue
} from 'selectors/selectors';
import SampleProfile from './images/sample-profile-image.svg';
import RegionIcon from './images/region-icon.svg';
import HelpIcon from './images/help-icon.svg';
import SignoutIcon from './images/sign-out-icon.svg';
import FilterSearch from 'components/filters-bar/FilterSearch';
import PropTypes from 'prop-types';
import { FilterDisplay, FilterType } from 'types/types';
import BlueCrossIcon from './images/blue-cross.svg';
import { hideUserProfileOverlay, logout } from 'slices/AppSlice';
import { resetFilters } from 'slices/FiltersSlice';

import {
    LOGIN_ROUTE,
    MARKET_ROUTE,
    RM_ROUTE,
    TEAM_ROUTE
} from 'constants/routes';
import { useLocation, useNavigate } from 'react-router-dom';

const UserProfile = ({ onFiltersChanged }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname: route } = useLocation();

    const zoneLabel = useSelector(selectZoneLabel);
    const zoneValue = useSelector(selectZoneValue);
    const zoneDropdownValues = useSelector(selectZoneDropdownValues);
    const hasUserProfileOverlay = useSelector(selectShowUserProfileOverlay);
    const user = useSelector(selectLoggedInUser);

    const [isZoneInFocus, setIsZoneInFocus] = useState(false);
    const [showZoneOptions, setShowZoneOptions] = useState(false);
    const [zoneSearchFieldValue, setZoneSearchFieldValue] = useState('');
    const [zoneSearchFieldLength, setZoneSearchFieldLength] = useState(0);

    const isMarketTeamOrRmRoute = [MARKET_ROUTE, TEAM_ROUTE, RM_ROUTE].includes(
        route
    );
    const handleCrossIconOnClick = () => {
        dispatch(hideUserProfileOverlay());
    };

    const onLogoutClick = () => {
        dispatch(hideUserProfileOverlay());
        dispatch(logout());
        navigate(LOGIN_ROUTE);
    };

    return (
        hasUserProfileOverlay && (
            <div className={styles.wrapper}>
                <div className={styles.titleContainer}>
                    <p>User Profile</p>
                    <img
                        src={BlueCrossIcon}
                        alt={''}
                        className={styles.blueCrossIcon}
                        onClick={handleCrossIconOnClick}
                    />
                </div>
                <div className={styles.profileContainer}>
                    <img src={SampleProfile} />
                    <div>
                        <p className={styles.profileFirstLine}>
                            {' '}
                            {user ? user.name : 'John Doe'}
                        </p>
                        <p className={styles.profileSecondLine}>
                            Risk Manager, Singapore
                        </p>
                    </div>
                </div>
                <div className={styles.regionContainer}>
                    <img src={RegionIcon} />
                    <p className={styles.regionTitle}>Region view</p>
                    {isMarketTeamOrRmRoute ? (
                        <div>{zoneLabel}</div>
                    ) : (
                        <FilterSearch
                            style={{ width: 180 }}
                            filterName={FilterDisplay.USER_PROFILE_ZONE}
                            filterType={FilterType.ZONE}
                            searchFieldValue={zoneSearchFieldValue}
                            setSearchFieldValue={setZoneSearchFieldValue}
                            searchFieldLength={zoneSearchFieldLength}
                            setSearchFieldLength={setZoneSearchFieldLength}
                            showOptions={showZoneOptions}
                            setShowOptions={setShowZoneOptions}
                            isInFocus={isZoneInFocus}
                            setIsInFocus={setIsZoneInFocus}
                            label={zoneLabel}
                            value={zoneValue}
                            options={zoneDropdownValues}
                            onFiltersChanged={onFiltersChanged}
                            resetFilters={resetFilters}
                            showFilterName={false}
                        />
                    )}
                </div>
                <div className={styles.helpContainer}>
                    <img src={HelpIcon} />
                    <p>Help</p>
                </div>
                <div className={styles.logoutContainer} onClick={onLogoutClick}>
                    <img src={SignoutIcon} />
                    <p>Logout</p>
                </div>
            </div>
        )
    );
};

UserProfile.propTypes = {
    onFiltersChanged: PropTypes.func
};

export default UserProfile;
